import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { formatDateTime, formatDate } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { User, Phone, MessageCircle, Mail, Instagram, Cake, Users2 } from "lucide-react";

export default function PessoaPerfil() {
  const { id } = useParams();
  const nav = useNavigate();
  const [p, setP] = useState(null);
  const [mun, setMun] = useState(null);
  const [contatos, setContatos] = useState([]);

  useEffect(() => {
    (async () => {
      const pr = await api.get(`/pessoas/${id}`);
      setP(pr.data);
      const [mr, cr] = await Promise.all([
        api.get(`/municipios/${pr.data.municipio_id}`),
        api.get(`/pessoas/${id}/contatos`),
      ]);
      setMun(mr.data); setContatos(cr.data);
    })();
  }, [id]);

  if (!p) return <div className="text-slate-500">Carregando...</div>;

  return (
    <div className="space-y-6" data-testid="pessoa-perfil">
      <div className="flex items-center gap-4">
        <div className="w-16 h-16 rounded-2xl bg-indigo-100 text-indigo-700 flex items-center justify-center">
          <User className="w-8 h-8" />
        </div>
        <div>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">{p.nome}</h1>
          <div className="text-slate-500 text-sm">
            {p.funcao}{p.partido ? ` · ${p.partido}` : ""} · <button className="text-blue-600 hover:underline" onClick={() => nav(`/municipio/${p.municipio_id}`)}>{mun?.nome} / {mun?.uf}</button>
          </div>
        </div>
      </div>

      <Card className="p-6 rounded-2xl">
        <h2 className="font-display font-bold text-xl mb-4">Contato</h2>
        <div className="grid md:grid-cols-2 gap-3 text-sm">
          <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-slate-400" /> Telefone: <b>{p.telefone || "—"}</b></div>
          <div className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-emerald-500" /> WhatsApp: <b>{p.whatsapp || "—"}</b></div>
          <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-slate-400" /> E-mail: <b>{p.email || "—"}</b></div>
          <div className="flex items-center gap-2"><Instagram className="w-4 h-4 text-pink-500" /> Instagram: <b>{p.instagram || "—"}</b></div>
          <div className="flex items-center gap-2"><Users2 className="w-4 h-4 text-slate-400" /> Partido: <b>{p.partido || "—"}</b></div>
          <div className="flex items-center gap-2"><Cake className="w-4 h-4 text-amber-500" /> Nascimento: <b>{p.data_nascimento ? formatDate(p.data_nascimento + "T12:00:00") : "—"}</b></div>
        </div>
      </Card>

      <Card className="p-6 rounded-2xl">
        <h2 className="font-display font-bold text-xl mb-4">Histórico de contatos ({contatos.length})</h2>
        <div className="space-y-2 max-h-[500px] overflow-y-auto">
          {contatos.map((c) => (
            <div key={c.id} className="flex items-start gap-2 border-l-2 border-slate-200 pl-3 py-2">
              {c.canal === "ligacao"
                ? <Phone className="w-4 h-4 text-blue-500 mt-0.5" />
                : <MessageCircle className="w-4 h-4 text-emerald-500 mt-0.5" />}
              <div className="flex-1">
                <div className="text-sm font-semibold">{c.canal === "ligacao" ? "Ligação" : "WhatsApp"}</div>
                {c.observacao && <div className="text-xs text-slate-600 mt-0.5">{c.observacao}</div>}
                {c.data_retorno && <div className="text-xs text-blue-700 font-semibold mt-0.5">📅 Retorno: {formatDate(c.data_retorno + "T12:00:00")}</div>}
                <div className="text-xs text-slate-400">{formatDateTime(c.data)}</div>
              </div>
            </div>
          ))}
          {contatos.length === 0 && <div className="text-slate-400 text-sm text-center py-6">Sem contatos registrados.</div>}
        </div>
      </Card>
    </div>
  );
}
